<success-screen class="bp-modal mod-lg">
	<bp-modal-header
		header
		[title]="isMultichain ? ('send_via' | translate: [cryptoName, networkName]) : ('send' | translate)">
		<a right (click)="close()" href="javascript:;" (keydown.enter)="close()" [tabIndex]="0">
			{{ "close" | translate }}
		</a>
	</bp-modal-header>
	<div content class="success-content-inner">
		<div [ngClass]="isMultichain ? 'multichain-symbol' : ''" class="success-symbol mt-20 mb-20 mod-email">
			<span class="bpi__icon-email"></span>
		</div>
		<div [ngClass]="isMultichain ? 'multichain-title' : ''" class="success-headline mb-15">{{
			"you-got-mail" | translate
		}}</div>
		<p [ngClass]="isMultichain ? 'multichain-subtitle' : ''" class="text-light text-center mb-15">{{
			"click-link-in-email" | translate
		}}</p>
		<div [ngClass]="isMultichain ? 'multichain-resend' : ''" class="text-center mb-20">
			<button (click)="resendEmail()" class="btn btn-primary btn-wide" type="button">
				{{ "resend-email" | translate }}
			</button>
		</div>
		<div class="text-center">
			<a (click)="cancel()" href="javascript:;">{{ "cancel-transaction" | translate }}</a>
		</div>
	</div>
</success-screen>
